import { CarregandoBloco, CarregandoFormulario } from "../../../components/carregando";
import useIfoodConnection from "./useIfoodConnection";
import StatusLojaCard from "./StatusLojaCard";
import ConectarLojaCard from "./ConectarLojaCard";
import LojaIfoodCard from "./LojaIfoodCard";

/** Conexão: loja vinculada (estado no iFood + escuta) e o passo a passo para
 *  conectar. Pausar/reabrir é o botão Fechar/Abrir loja do cabeçalho; aceite
 *  automático é o do Delivery — nada disso se repete aqui (regra do dono, 16/09). */
export default function ConexaoTab() {
  const { data, loading, busy, reload, connect, disconnect } = useIfoodConnection();

  if (loading && !data) {
    // Carregamento com cards (25/10/2026): aviso e passo a passo piscando no lugar do spinner.
    return (
      <div className="space-y-5 max-w-3xl">
        <CarregandoBloco altura="h-20" />
        <CarregandoFormulario campos={3} />
      </div>
    );
  }
  const merchants = data?.merchants || [];

  return (
    <div className="space-y-5 max-w-3xl">
      {!data?.credentials_configured && (
        <div className="p-4 rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-700 text-sm text-amber-800 dark:text-amber-300">
          A conexão do Núcleo com o iFood ainda não está ativa neste servidor. Assim que estiver, esta tela mostra o passo a passo.
        </div>
      )}
      {merchants.length === 0 && data?.polling?.waiting_authorization && (
        <div className="rounded-xl border border-amber-300/60 bg-amber-500/10 px-4 py-3 text-sm text-amber-800 dark:text-amber-300">
          <p className="font-semibold">Aguardando a primeira loja autorizar o Nucleo PDV</p>
          <p className="mt-1 text-[13px] leading-relaxed">
            O aplicativo já está homologado no iFood. O iFood só libera o acesso depois que uma loja autoriza o
            Nucleo PDV no Portal do Parceiro (Aplicativos → Nucleo PDV → Permitir). Feito isso, a loja aparece
            aqui em até 10 minutos para você conectar.
          </p>
        </div>
      )}
      {merchants.length > 0 && (
        <StatusLojaCard data={data} busy={busy} onDisconnect={disconnect} onReload={() => reload(true)} />
      )}
      {merchants.length > 0 && (
        <LojaIfoodCard semModuloLoja={merchants.some((m) => m.merchant_module === false)} />
      )}
      <ConectarLojaCard onConnect={connect} busy={busy} temLoja={merchants.length > 0} />
    </div>
  );
}
